module.exports = __webpack_public_path__ + "static/Welcome-be926d9a89751f59b582581f49b50b45.svg";